import React, { useEffect, useState } from "react";
import styles from "./ImageCarousel.module.css";
import chevronLeft from "../../assets/arrow_red.svg";
import image1 from '../../assets/work.jpg'
import image2 from '../../assets/work_1.png'
import image3 from '../../assets/work_2.jpg'

const ImageCarousel = () => {
  const [currentImage, setCurrentImage] = useState(0);

  const images = [
    {
      src: image1,
      alt: "Dashboard Image 1",
      id: 0,
    },
    {
      src: image2, 
      alt: "Dashboard Image 2",
      id: 1,
    },
    {
      src: image3,
      alt: "Dashboard Image 3", 
      id: 2,
    },
  ];

  const nextImage = () => {
    setCurrentImage((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImage(
      (prev) => (prev - 1 + images.length) % images.length
    );
  };

  const goToImage = (index) => {
    setCurrentImage(index);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextImage();
    }, 5000);

    return () => clearInterval(interval); 
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.carouselContainer}>
        <button
          onClick={prevImage}
          className={`${styles.navButton} ${styles.navLeft}`}
        >
         <img src={chevronLeft} alt="chevron-left" width={42} height={42} className={styles.flipHorizontal}/>
        </button>

        <div className={styles.imageContent}>
          <img 
            src={images[currentImage].src}
            alt={images[currentImage].alt}
            className={styles.carouselImage}
          />
        </div>

        <button
          onClick={nextImage}
          className={`${styles.navButton} ${styles.navRight}`}
        >
         <img src={chevronLeft} alt="chevron-right" width={42} height={42} className={styles.chevronLeft} />
        </button>
      </div>

      <div className={styles.dots}>
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => goToImage(index)}
            className={`${styles.dot} ${
              index === currentImage ? styles.activeDot : ""
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageCarousel;